export default __webpack_public_path__ + "static/media/Snd_Lizzard.da40af4d.mp3";